export class UniversityInfoCardModel {
  name: string = ''
  description: string = ''
  phoneTitle: string = ''
  phoneNumber: string = ''
}
